import React from "react";
import "../../../styles/main.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { BsArrowRight } from "react-icons/bs";
import HtmlParser from "react-html-parser";

function AboutUs({ About, Values }) {
  return (
    <>
      <div className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6 aboutimg-div ">
              <img
                className="aboutimg "
                src={
                  process.env.REACT_APP_IMAGE_BASE_URL +
                  About?.Image?.data?.attributes?.url
                }
              />
            </div>
            <div className="col-md-6 col-lg-6 px-5">
              <div className="banner-txt">
                <p className="banner-num">02</p>
                <span className="banner-title">{About?.Subtitle}</span>
              </div>
              <div className="txt2 mt-4">{HtmlParser(About?.Title)}</div>
              <p className="txt3 mt-4">{HtmlParser(About?.Description)}</p>
              <a href="/about" className="btn2 btn2-color btn2-l-r mt-5">
                Know More&nbsp;&nbsp;&nbsp;
                <BsArrowRight />
              </a>
            </div>
          </div>
          <div className="row pb-5 mob-mt-2">
            {Values?.map((dataValue) => (
              <div
                className="col-md-3 col-lg-3 col-6 data1 mt-5"
                key={dataValue?.id}
              >
                <div className="mt-2 mx-5 about-us-sub-con">
                  <div className="txt4">{dataValue?.Title}</div>
                  <p className="txt5">{dataValue?.Subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
